import { createAction } from 'redux-actions';

export const tabSuccess = createAction('TAB_SUCCESS');

export const setSelectedTab = (tab) => {
    return (dispatch)=>{
  dispatch(tabSuccess( tab ));
    }
};
